import Section from './HottestColorsSection'
import isEmpty from './HottestColorsIsEmpty'

export default { Section, isEmpty }
